<!--
/****
/* Individual products are loaded with the getProduct mixin.
/* For instructions related to connecting your invetory to
/* Nacelle, please refer to:
/*
/* https://docs.getnacelle.com/getting-started.html#_2-product-settings
/****
-->
<template>
  <div class="p-product-bracelet-page">
    <div
      class="nosto_page_type"
      style="display:none"
    >
      product
    </div>
    <section class="u-margin-bottom-xx-large">
      <product-info
        v-if="product"
        :product="product"
        :products="pdpCollectionData.products"
        :size.sync="selectedRingSize"
        @engraving="startEngraving"
        @update:variant="currentProductVariant = $event"
      >
        <template v-slot:default="slotProps">
          <!--
            uses scoped slots to pass the props back up to this scope
            @link https://vuejs.org/v2/guide/components-slots.html#Scoped-Slots

            geofence is assumed denied until we get a confirmed positive
            response geoip api

            if a product is NOT in stock, show back in stock notification prompt
          -->
          <template v-if="!variantAvailableLoading">
            <back-in-stock
              v-if="showBackInStock(slotProps, variantAvailable)"
              :product="slotProps.product"
              :variant="slotProps.variant"
            />
            <product-add-to-cart-button
              v-else
              v-bind="{
                ...slotProps,
                shoppingGivesDetected
              }"
            />
          </template>
          <loader v-else />
        </template>
        <template
          v-if="product"
          v-slot:rating
        >
          <!-- Yotpo Star Ratings -->
          <star-rating
            :product="product"
            class="u-margin-bottom-x-small"
            style="display: inline-block"
          />
        </template>
        <template v-slot:recommendations>
          <div
            v-if="shoppingGivesEnabled"
            id="shopping-gives-widget"
            ref="shoppingGivesWidget"
            class="p-product-bracelet-page__shopping-gives-widget"
            @click="detectShoppingGivesState"
          />
          <product-recommendations
            v-if="frequentlyBoughtTogether"
            :recommendations="frequentlyBoughtTogether"
          />
        </template>
      </product-info>
    </section>
    <a v-utm-adder id="more" />
    <section class="p-product-bracelet-page__details">
      <div class="l-container">
        <tabs
          :tabs="tabs"
          :get-product-function="fetchProduct"
        />
      </div>
    </section>
    <section>
      <row
        v-if="rowData"
        v-bind="rowData.data"
        :get-product-function="fetchProduct"
      />
    </section>
    <shoppable-instagram
      class="l-container u-margin-bottom-x-large"
      :content="shoppableInstagram"
    />
    <section
      v-if="onTheOtherHand && onTheOtherHand.length"
      class="l-container u-margin-bottom-x-large"
    >
      <h2 class="t-heading-5 u-margin-bottom-medium">
        ON THE OTHER HAND.
      </h2>
      <div id="productpage-nosto-1">
        <product-carousel :collections="onTheOtherHand" />
      </div>
    </section>
    <section class="l-container u-margin-bottom-x-large">
      <client-only>
        <!-- Yotpo Reviews -->
        <reviews-widget
          v-if="product"
          :product="product"
          :pathname="$route.fullPath"
        />
      </client-only>
    </section>
  </div>
</template>

<script>
import BackInStock from '~/components/nacelle/BackInStock'
import getProductInCard from "~/mixins/getProductInCard";
import gtmProductEvents from '~/mixins/gtmProductEvents'
import nmerge from '~/utils/merge-requests'
import nosto from '~/mixins/nosto'
import productHandle from '~/mixins/productHandle'
import productMetafields from '~/mixins/productMetafields'
import productPageDetails from '~/mixins/productPageDetails'
import productVariantAvailable from '~/mixins/productVariantAvailable'
import sezzle from '~/mixins/sezzle'
import { getCollectionFromProps } from '~/mixins/getCollectionFromProps'
import { mapSections } from '@/utils/contentfulHelper'
import { mapState, mapActions } from 'vuex'
export default nmerge({
  components: {
    BackInStock
  },
  mixins: [
    getCollectionFromProps('pdpCollection'),
    sezzle(),
    nosto({
      elements: ['productpage-nosto-1', 'productpage-nosto-2', 'nosto-stl']
    }),
    getProductInCard,
    productMetafields,
    productPageDetails,
    productHandle,
    productVariantAvailable,
    gtmProductEvents,
  ],
  watch: {
    async product() {
      if (this.product) {
        await this.$nextTick()
        this.setEngravingContext({
          mode: 'pdp',
          product: this.product,
          variant: this.currentProductVariant
        })
      }
    }
  },
  computed: {
    ...mapState('engraving', {
      engravingProduct: ({ product }) => product
    }),
    engravingVariant: {
      get() {
        return this.$store.state.engraving.variant
      },
      set(variant) {
        this.setEngravingContext({
          mode: 'pdp',
          product: this.product,
          variant
        })
      }
    },
    openEngraving: {
      get() {
        return this.$store.state.engraving.open
      },
      set(open) {
        if (open) {
          this.setEngravingContext({
            mode: 'pdp',
            product: this.product,
            variant: this.currentProductVariant
          })
          this.$nextTick(() => this.$store.dispatch('engraving/open'))
        } else {
          this.$store.dispatch('engraving/close')
        }
      }
    },
    showEngravingScreen() {
      const product = this.engravingProduct
      let result = false
      if (product && product.metafields) {
        result = !!product.metafields.find(obj => {
          return obj.key == 'engraving'
        })
      }
      return result
    },
    isGiftCard() {
      return this.product.vendor.toLowerCase().includes('rise.ai')
    },
    rowData() {
      if (this.productPageContent) {
        let sections = mapSections(this, this.productPageContent.sections)
        for (let section of sections) {
          if (section.contentType == 'row') {
            return section
          }
        }
        return this.productPageContent[1]
      }
    },
  },
  methods: {
    ...mapActions('engraving', {
      setEngravingContext: 'setContext'
    }),
    startEngraving(data) {
      this.currentProductVariant = data.variant
      this.selectedRingSize = parseInt(data.size)
      this.openEngraving = true
    },
    closeEngraving() {
      this.openEngraving = false
    },
  }
})
</script>

<style lang="scss" scoped>
  .p-product-bracelet-page {
    padding: $section-padding;
    &__details {
      @include themify($themes) {
        background-color: themed('background', 'xx-light');
      }
    }
    &__shopping-gives-widget {
      height: rem(50px);
      overflow: hidden;
      margin-top: rem(20px);
    }
  }
</style>
